import { useMutation } from '@tanstack/react-query';
import Toaster from 'src/app/utilities/helpers/Toaster';
import { parseErrors } from 'src/app/utilities/helpers/errors';
import ticketLinkImportService from 'src/data/services/ticketLinkImportService';

export const useRematchTicketLinkImport = (onSuccess?: () => void) => {
    return useMutation({
        mutationFn: (ticketLinkImportId: string) =>
            ticketLinkImportService.rematchTicketLinkImport(ticketLinkImportId),
        onSuccess: () => {
            Toaster.toast('Retry match!', { variant: 'success' });
            onSuccess?.();
        },
        onError: (errors) => Toaster.toastErrors(parseErrors(errors)),
    });
};
